import React from 'react'
import styled from 'styled-components'
import { Modal, Fonts, Button } from 'components/base-ui'
import { useTranslation } from 'react-i18next'

const warningImg = `${process.env.PUBLIC_URL}/assets/generic/warning-circle.svg`

interface ModalConfirmWantToChangePaymentMethodProps {
  isOpen: boolean
  isProcessing: boolean
  isAdjustmentApplied: boolean
  onRequestClose: VoidFunction
  onClickConfirm: VoidFunction
}

const ModalConfirmWantToChangePaymentMethod = ({
  isOpen,
  isProcessing,
  isAdjustmentApplied,
  onRequestClose,
  onClickConfirm,
}: ModalConfirmWantToChangePaymentMethodProps) => {
  const { t } = useTranslation()
  return (
    <Modal hideCloseButton={false} isOpen={isOpen} onRequestClose={onRequestClose}>
      <ModalContent>
        <TextWrapper>
          <img alt="generic-warning-circle-icon" src={warningImg} />
          <Title>
            {isAdjustmentApplied
              ? t('dineInModalConfirmChangePaymentWithAdjustmentTitle')
              : t('dineInModalConfirmChangePaymentTitle')}
          </Title>

          {isAdjustmentApplied && <Description>{t('dineInModalConfirmChangePaymentWithAdjustmentDesc')}</Description>}
        </TextWrapper>
        <WrapperButton>
          <Button float md2 isProcessing={isProcessing} disabled={isProcessing} onClick={onClickConfirm}>
            {t('dineInModalConfirmChangePaymentBtnConfirm')}
          </Button>
          <Button float md2 outline onClick={onRequestClose} style={{ whiteSpace: 'nowrap' }}>
            {t('dineInModalConfirmChangePaymentBtnBack')}
          </Button>
        </WrapperButton>
      </ModalContent>
    </Modal>
  )
}

export default ModalConfirmWantToChangePaymentMethod

const ModalContent = styled.div`
  padding-top: ${({ theme }) => theme.spacing['6XL']};
  padding-bottom: ${({ theme }) => theme.spacing.XL};
  text-align: center;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: ${({ theme }) => theme.spacing.XL};
  margin-bottom: ${({ theme }) => theme.spacing['6XL']};
`

const Title = styled(Fonts.H3)``

const Description = styled(Fonts.H4)`
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray900};
`

const WrapperButton = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.XS};
`
